const COUNTRY_CODE_ONLY_REGEX = /^\+[0-9]{1,3}$/;

export const isCountryCodeOnly = (value: string): boolean => COUNTRY_CODE_ONLY_REGEX.test(value) || value === '+';
